module.exports = __webpack_public_path__ + "img/games.327be02e.svg";